export const GET_CYCLES = 'grades/GET_CYCLES'
export const GET_CYCLES_SUCCESSFUL = 'grades/GET_CYCLES_SUCCESSFUL'
export const GET_CYCLES_FAILURE = 'grades/GET_CYCLES_FAILURE'
